/* =========================================================
   Eichinger Caviar – Land- & Sprachwaehler (Custom, ohne App)
   Ein Klick auf ein Land oder eine Sprache uebernimmt sofort.
   Ohne JavaScript funktioniert es genauso (normaler Form-Submit).
   ========================================================= */

if (typeof EcLocaleDialog !== 'function') {
  class EcLocaleDialog extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.countryInput = this.querySelector('[data-ec-loc-country-input]');
      this.localeInput = this.querySelector('[data-ec-loc-locale-input]');
      this.closeButton = this.querySelector('[data-ec-loc-close]');
      this.lastFocused = null;
      this.submitting = false;

      this.onKeydown = this.onKeydown.bind(this);

      this.addEventListener('click', (event) => {
        const option = event.target.closest('[data-ec-loc-country], [data-ec-loc-locale]');
        if (option) {
          event.preventDefault();
          if (this.submitting) return;
          this.select(option);
          this.apply(option);
          return;
        }
        if (event.target.closest('[data-ec-loc-close]')) {
          event.preventDefault();
          this.close();
        }
      });
    }

    connectedCallback() {
      // Aus dem Header herausloesen: dessen Sticky-Transform wuerde das
      // Overlay sonst einfangen und auf die Hoehe der Leiste beschneiden.
      if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    apply(option) {
      if (!this.form) return;
      this.submitting = true;
      option.setAttribute('aria-busy', 'true');
      this.classList.add('is-submitting');
      // Auswahl steckt in den Hidden-Inputs, daher ohne Submitter absenden
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }

    select(option) {
      const list = option.closest('ul');
      if (list) {
        list.querySelectorAll('.ec-loc__option').forEach((item) => {
          item.classList.remove('is-selected');
          item.removeAttribute('aria-current');
        });
      }
      option.classList.add('is-selected');
      option.setAttribute('aria-current', 'true');

      if (option.hasAttribute('data-ec-loc-country') && this.countryInput) {
        this.countryInput.value = option.getAttribute('data-ec-loc-country');
      }
      if (option.hasAttribute('data-ec-loc-locale') && this.localeInput) {
        this.localeInput.value = option.getAttribute('data-ec-loc-locale');
      }
    }

    open(trigger) {
      this.lastFocused = trigger || document.activeElement;
      document.documentElement.classList.add('ec-loc-is-open');
      this.classList.add('is-open');

      document.querySelectorAll('[data-ec-loc-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'true');
      });

      document.addEventListener('keydown', this.onKeydown);

      window.setTimeout(() => {
        const selected = this.querySelector('.ec-loc__option.is-selected');
        (selected || this.closeButton || this).focus({ preventScroll: true });
      }, 60);
    }

    close() {
      document.documentElement.classList.remove('ec-loc-is-open');
      this.classList.remove('is-open');

      document.querySelectorAll('[data-ec-loc-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      document.removeEventListener('keydown', this.onKeydown);

      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus({ preventScroll: true });
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab' && event.keyCode !== 9) return;

      const focusable = Array.from(
        this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (typeof customElements.get('ec-locale-dialog') === 'undefined') {
    customElements.define('ec-locale-dialog', EcLocaleDialog);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ec-loc-open]');
    if (!trigger) return;

    const dialog = document.getElementById('ec-loc-dialog');
    if (!dialog || typeof dialog.open !== 'function') return;

    event.preventDefault();
    event.stopPropagation();
    dialog.open(trigger);
  });
}
